import './response_template.js.coffee';# Added by Script
#
#  Initialize with Customer.ResponseTemplateCollection.getCollection() for cache
#

class Customer.ResponseTemplateCollection extends Backbone.Collection

  model: Customer.ResponseTemplate
# url: '/keepcon/settings/response_templates'
  url: ->
    base = window.location.pathname
    "#{base}/response_templates"

  @getCollection: () ->
    Keepcon.Collections.responseTemplates ||= new Customer.ResponseTemplateCollection()
    Keepcon.Collections.allResponseTemplatesModels ||= Keepcon.Collections.responseTemplates.clone().models
    Keepcon.Collections.responseTemplates

  @getEmptyResponseCollection: () ->
    @getCollection()
    collection = Keepcon.Collections.responseTemplates
    collection.has_more = true
    collection

  @getExpandedCollection: () ->
    @getCollection()

  initialize: ->
    @fetch().success () =>
      @fetched = true

  parse: (response) ->
    @labels = response.labels
    @possibleTags = response.tags
    @hiddenTags = response.hidden_tags
    @all_types = response.all_types
    @filtered_types = response.filtered_types
    @groups = response.groups
    super(response.templates)

  groupTags: ->
    @tagsGroupped ||= _.groupBy(@possibleTags, 'code')

  _getDescriptions: (tags) ->
    tagsDescriptions = {}
    for tag in tags
      tagsDescriptions[tag.code] = tag.description
    tagsDescriptions

  getTagDescription: (tag)->
    if(@groupTags()[tag]) # existe
      return this.groupTags()[tag][0]['description']
    else
      return tag

  getLabelName: (id) ->
    label = _.find @labels, (label) -> label.id.toString() == id.toString()
    return label.name if(label?)

  getLabelsNames: ->
    _.map @labels, (label) =>
      @getLabelName(label.id)

  getLabelIDs: (labels) ->
    ids = []
    _.each labels, (label) =>
      id = @_labelNameToID(label)
      ids.push(id) if id
    ids

  _labelNameToID: (labelName) ->
    _label = _.find @labels, (label) ->
      label.name == labelName
    _label.id.toString() if _label

  tagsByDescription: ->
    _.sortBy(@possibleTags, 'description')

  idToType: (id) ->
    _.find @all_types, (type) ->
      type.id == id

  getAccountModels: ->
    _.filter @models, (mod) ->
      mod.isFromAccount()

  getClientModels: ->
    _.filter @models, (mod) ->
      mod.isFromClient()

  finalText: (models, user, ticketId, username) ->
    _.reduce models, (text, model) ->
      text + "#{model.replacedText(user, undefined, ticketId, username)}\n"
    , ''

  allModels: ->
    Keepcon.Collections.allResponseTemplatesModels

  hasMatchingTagsForType: (tags, type, alwaysShowUntyped) ->
    @getMatchingTagsForType(@allModels(), tags, type, alwaysShowUntyped).length > 0

  hasMatchingLabelsForType: (labels, type, alwaysShowUntyped) ->
    @getMatchingLabelsForType(@allModels(), labels, type, alwaysShowUntyped).length > 0

  getMatchingTagsForType: (models, tags, type, alwaysShowUntyped) ->
    return [] if _.isEmpty(tags)
    @filterByType @filterByTags(models, tags), type, alwaysShowUntyped

  getMatchingLabelsForType: (models, labels, type, alwaysShowUntyped) ->
    return [] if _.isEmpty(labels)
    @filterByType @filterByLabels(models, labels), type, alwaysShowUntyped

  getMatchingTagsModels: (models, tags_dict) ->
    if tags_dict.any
      return models

    tags = tags_dict.list
    filtered_models = @filterByTags(models, tags)
    return filtered_models

  getMatchingLabelsModels: (models, labels_dict) ->
    if labels_dict.any
      return models

    labels = @getLabelIDs(labels_dict.list)
    filtered_models = @filterByLabels(models, labels)
    if labels_dict.include_global
      return filtered_models.concat(@filterGlobalLabels(models))
    else
      return filtered_models

  getModelsMatching: (tags, labels, type, alwaysShowUntyped) ->
    typeFilter = @filterByType(@allModels(), type, alwaysShowUntyped)
    tagsFilter = @getMatchingTagsModels(typeFilter, tags)
    labelsFilter = @getMatchingLabelsModels(tagsFilter, labels)
    return labelsFilter

  getModelsMatchingWithTextSearch: (textToSearch, tags, labels, type, alwaysShowUntyped) ->
    typeFilter = @filterByType(@allModels(), type, alwaysShowUntyped)
    filtered_models = _.filter(typeFilter, (template) -> (template.attributes.title.toUpperCase().indexOf(textToSearch.toUpperCase()) != -1) || (template.attributes.template.toUpperCase().indexOf(textToSearch.toUpperCase()) != -1))
    tagsFilter = @getMatchingTagsModels(filtered_models, tags)
    labelsFilter = @getMatchingLabelsModels(tagsFilter, labels)
    return labelsFilter

  filterByType: (models, type, alwaysShowUntyped) ->
    result = @doFilterByType(models, type)
    if result.length > 0
      if alwaysShowUntyped
        result = _.union(result, @filterUntyped(models))
    else
      result = @filterUntyped(models)
    result

  filterByTags: (templates, tags) ->
    _.filter templates, (template) =>
      template.isActive() && template.matchesIntelligentTags(tags)

  filterByLabels: (templates, labels) ->
    _.filter templates, (template) =>
      template.isActive() && template.matchesIntelligentLabels(labels)

  filterGlobalLabels: (templates) ->
    _.filter templates, (template) =>
      _.isEmpty(template.intelligentGroupsList())

  doFilterByType: (models, type) ->
    _.filter models, (mod) =>
      mod.isForType(type, @all_types)

  filterUntyped: (models) ->
    _.filter models, (mod) ->
      !mod.isOnlyForSpecificTypes()

  minLettersToSearch: (collection_size) =>
    if collection_size >= 400
      return 3
    else if collection_size >= 200
      return 2
    else
      return 1
